(() => {
  function init(context = document) {
    context.querySelectorAll('[data-pe-knowledge]').forEach(hub => {
      if (hub.dataset.ready) return;
      hub.dataset.ready = 'true';
      let family = 'all';
      const input = hub.querySelector('[data-pe-knowledge-search]');
      const rows = [...hub.querySelectorAll('[data-pe-knowledge-topic]')];
      const normalise = s => s.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const filter = () => {
        const terms = normalise(input.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        rows.forEach(row => {
          const matches = (family === 'all' || family === row.dataset.peKnowledgeTopic) && terms.every(t => normalise(row.textContent + ' ' + (row.dataset.peKnowledgeKeywords || '')).includes(t));
          row.hidden = !matches;
          if (matches) count++;
        });
        hub.querySelector('[data-pe-knowledge-count] span').textContent = count;
        hub.querySelector('[data-pe-knowledge-empty]').hidden = count !== 0;
      };
      hub.querySelectorAll('[data-pe-knowledge-filter]').forEach(button => button.addEventListener('click', () => {
        family = button.dataset.peKnowledgeFilter;
        const url = new URL(location.href);
        if (family === 'all') url.searchParams.delete('family'); else url.searchParams.set('family', family);
        history.replaceState(null, '', url);
        hub.querySelectorAll('[data-pe-knowledge-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        filter();
      }));
      input.addEventListener('input', filter);
      filter();
      const desired = new URLSearchParams(location.search).get('family');
      if (['windows','office','visio','project','server'].includes(desired)) {
        hub.querySelector(`[data-pe-knowledge-filter="${desired}"]`).click();
      }
    });
    const topic = new URLSearchParams(location.search).get('topic');
    if (topic && /^knowledge(?:-(windows|office|visio|project|dns|rdp))?$/.test(topic)) {
      const input = context.querySelector('#ContactForm-body');
      const guide = context.querySelector('[data-pe-knowledge-contact]');
      if (guide) guide.hidden = false;
      if (input && guide && !input.value.trim()) input.value = (guide.getAttribute('data-pe-knowledge-' + topic.replace('knowledge-', '')) || '') + '\n\n' + guide.dataset.peKnowledgeBody;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();